import {Injectable} from '@angular/core';
import {ConfigService} from './config.service';
import {ECOMMERCE_TYPE, PREORDER_TYPE} from '../constants/order-types';




@Injectable()
export class MultiTenantService {

    constructor(private configService: ConfigService) {}


    public get logoImageUrl(): string {
        return this.configService.features.logoUrl;
    }

    public get orderWindowLabel(): string {
        return this.configService.fedInfoFeature.orderWindowLabel;
    }

    public get showOrderWindowLabel(): boolean {
        return this.configService.fedInfoFeature.showOrderWindow;
    }


    public get showOrderWindowOrdersLabel(): boolean {
        return this.configService.fedInfoFeature.showOrderWindowOrders;
    }

    public get orderWindowOrdersLabel(): string {
        return this.configService.fedInfoFeature.orderWindowOrdersLabel;
    }

    public get showOnDemandOrdersLabel(): boolean {
        return this.configService.fedInfoFeature.showOnDemandOrders;
    }

    public get onDemandOrdersLabel(): string {
        return this.configService.fedInfoFeature.onDemandOrdersLabel;
    }

    public get onDemandLabel(): string {
        return this.configService.fedInfoFeature.onDemandLabel;
    }
    
    public get showOnDemandLabel(): boolean {
        return this.configService.fedInfoFeature.showOnDemand;
    }

    public get projectLabel(): string {
        return this.configService.features.clientName;
    }


    public get canShowWBS(): boolean {
        // return this.configService.features.showWBS;
        return this.configService.fedInfoFeature.showWbs;
    }
    public get canShowInternalOrder(): boolean {
        // return this.configService.features.showWBS;
        return this.configService.fedInfoFeature.showInternalOrder;
    }

    public get canShowBillingCodeDropdown(): boolean {
        return this.configService.fedInfoFeature.showBillingCodeDropdown;
    }

    public get showDeliveryComments(): boolean {
        return this.configService.fedInfoFeature.showDeliveryComments;
    }

    public get showOrderNotes(): boolean {
        return this.configService.fedInfoFeature.showOrderNotes;
    }
    public get showPlanningComments(): boolean {
        return this.configService.fedInfoFeature.showPlaningComments;
    }

    public get planningCommentsLabel(): string {
        return this.configService.fedInfoFeature.planningCommentsLabel;
    }


    public get showOrderNotesOrDeliveryComments(): boolean {
        return !!(this.configService.fedInfoFeature.showOrderNotes || this.configService.fedInfoFeature.showDeliveryComments);
    }

    public get deliveryCommentsLabel(): string {
        return this.configService.fedInfoFeature.deliveryCommentslabel;
    }

    // Since orderNotesLabel is used in many places not covered under this ticket,
    // creating new method that doesn't depend on delivery comments
    public get notesLabel(): string {
        return this.configService.fedInfoFeature.orderNotesLabel;
    }

    public get orderNotesLabel(): string {
        return this.showDeliveryComments ? this.configService.fedInfoFeature.deliveryCommentslabel : this.configService.fedInfoFeature.orderNotesLabel;
    }

    public get productCodeLabel(): string {
        return this.configService.fedInfoFeature.productCodeLabel;
    }

    public get showProductCodeLabel(): boolean {
        return this.configService.fedInfoFeature.showProductCode;
    }

    public get orderTypes(): {type: string; label: string}[] {
        const ORDER_TYPES = [
            {type: PREORDER_TYPE, label: `${this.configService.features.orderWindowLabel} Order`},
            {type: ECOMMERCE_TYPE, label: `${this.configService.features.onDemandLabel} Order`},
        ]

        return ORDER_TYPES;
    }

    public get productWrongWindowLabel(): string {
        return  `The product does not belong to active ${this.orderWindowLabel}. Please select a correct ${this.orderWindowLabel}`;

    }

    public getMappedBreadcrumbName(name: string): string {
        if (!name) {
            return '';
        }

        if (!name.startsWith('__')) {
            return name;
        }

        return name.replace('__BW__', this.orderWindowLabel).replace('__OD__', this.onDemandLabel);
    }

    public getMappedTitle(title: string): string {
        if (!title) {
            return '';
        }

        if (!title.startsWith('__')) {
            return title;
        }

        return title.replace('__BW__', this.orderWindowLabel).replace('__OD__', this.onDemandLabel);
    }

}

